import Auth from "./auth";

class Guard {

    admin(to, from, next) {
        Auth.g().role == 'admin' ? next() : next('/')
    }

    user(to, from, next) {
        Auth.logged() ? next() : next('/login')
    }

    guest(to, from, next) {
        !Auth.logged() ? next() : next('/')
    }

}

export default Guard = new Guard()
